import { render, staticRenderFns } from "./input-tag.vue?vue&type=template&id=7798e9ca&"
import script from "./input-tag.vue?vue&type=script&lang=js&"
export * from "./input-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports